"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientBookingTable = exports.ClientBookingProvider = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const edit_booking_window_1 = require("../../../calendar/edit_booking_window");
const helpers_1 = require("../../../utils/helpers");
const rest_provider_1 = require("../../../utils/rest_provider");
const table_renderers_1 = require("../../../utils/table_renderers");
const table_1 = require("../../../widgets/table");
const client_booking_cancel_window_1 = require("./client_booking_cancel_window");
function editBooking(id) {
    return function () {
        edit_booking_window_1.EditBookingWindow.edit(id);
    };
}
function cancelBooking(id, date, duration) {
    return function () {
        client_booking_cancel_window_1.ClientBookingCancelWindow.show(id, date, duration);
    };
}
exports.ClientBookingProvider = new rest_provider_1.RestProvider({
    name: "client_booking",
    create: "",
    update: "",
    show: "",
    delete: "",
    index: "GET|/me/bookings",
    new: ""
});
exports.ClientBookingTable = (0, table_1.createTable)({
    provider: exports.ClientBookingProvider,
    filters: {
        "incoming": "À venir uniquement",
        "history": "Consommées uniquement",
        "canceled": "Annulées & modifiées uniquement",
    },
    filterMode: "exclusive",
    fields: [
        {
            name: "id",
            label: "#",
            sortable: true,
            renderer: table_renderers_1.TableRenderers.tag(table_renderers_1.TableRenderers.identity),
        }, {
            name: "date",
            label: "Date",
            sortable: true,
            renderer: table_renderers_1.TableRenderers.tag(table_renderers_1.TableRenderers.date),
        }, {
            name: "duration",
            label: "Durée (h)",
            sortable: false,
            renderer: table_renderers_1.TableRenderers.tag(table_renderers_1.TableRenderers.time)
        }, {
            name: "status",
            label: "Statut",
            renderer: (mdl, _val) => {
                if (mdl.canceled) {
                    if (mdl.next_booking_id) {
                        return (0, helpers_1.tag)(`Modifié par #${mdl.next_booking_id}`);
                    }
                    else {
                        return (0, helpers_1.tag)("Annulé");
                    }
                }
                else {
                    if (mdl.confirmed) {
                        return (0, helpers_1.tag)("Consommé");
                    }
                    else {
                        return (0, helpers_1.tag)("À venir");
                    }
                }
            },
            sortable: false
        }
    ],
    actions: (mdl) => {
        let out = [];
        if (!mdl.canceled && !mdl.confirmed) {
            out.push((0, mithril_1.default)("button.button.is-primary", { onclick: editBooking(mdl.id) }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Éditer")));
            out.push((0, mithril_1.default)("button.button.is-danger", { onclick: cancelBooking(mdl.id, (0, moment_timezone_1.default)(mdl.date), mdl.duration) }, (0, helpers_1.iconSpan)("fa-times"), (0, mithril_1.default)("span", "Annuler")));
        }
        return (0, helpers_1.buttonGroup)(...out);
    },
    rowRenderer: (mdl, row) => {
        if (mdl.canceled) {
            return (0, mithril_1.default)("tr", { style: "color: #999;" }, row);
        }
        else {
            return (0, mithril_1.default)("tr", row);
        }
    },
    id: "client_booking",
    title: "Mon historique de réservation",
});
